<template>
  <div class="apply-container">
    <div class="apply-card">
      <header class="apply-header">
        <img src="@/assets/images/logo.png" alt="GoGuau" class="apply-logo" />
        <h1>Aplica como paseador GoGuau</h1>
        <p class="apply-sub">Tarda 8–10 minutos. Puedes pausar y volver cuando quieras.</p>
      </header>

      <ApplyStepper :current="currentStep" :total="11" v-if="!terminal" />

      <component
        :is="activeStepComponent"
        v-if="activeStepComponent"
        @next="onNext"
        @back="onBack"
        @goto="goto"
        @terminal="setTerminal"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ApplyStepper from './components/ApplyStepper.vue'

const Step1 = () => import('./steps/Step1Identification.vue')
const Step2 = () => import('./steps/Step2Personal.vue')
const Step3 = () => import('./steps/Step3Availability.vue')
const Step4 = () => import('./steps/Step4Mobility.vue')
const Step5 = () => import('./steps/Step5Situation.vue')
const Step6 = () => import('./steps/Step6Experience.vue')
const Step7 = () => import('./steps/Step7Zone.vue')
const Step8 = () => import('./steps/Step8Motivation.vue')
const Step9 = () => import('./steps/Step9Video.vue')
const Step10 = () => import('./steps/Step10Documents.vue')
const Step11 = () => import('./steps/Step11Pending.vue')

const ResultNoAprueba = () => import('./result/NoAprueba.vue')
const ResultFuturo = () => import('./result/Futuro.vue')
const ResultCooldown = () => import('./result/CooldownPending.vue')
const ResultReapplied = () => import('./result/Reapplied.vue')
const ResultApproved = () => import('./result/AlreadyApproved.vue')
const ResultVideoReview = () => import('./result/VideoUnderReview.vue')
const ResultRetirado = () => import('./result/Retirado.vue')

const STEPS = {
  1: Step1,
  2: Step2,
  3: Step3,
  4: Step4,
  5: Step5,
  6: Step6,
  7: Step7,
  8: Step8,
  9: Step9,
  10: Step10,
}

const TERMINAL = {
  pending: Step11,
  no_aprueba: ResultNoAprueba,
  futuro: ResultFuturo,
  cooldown: ResultCooldown,
  reapplied: ResultReapplied,
  approved: ResultApproved,
  video_review: ResultVideoReview,
  retirado: ResultRetirado,
}

export default {
  name: 'Apply',
  components: { ApplyStepper },
  data() {
    return { terminal: null }
  },
  computed: {
    ...mapState({
      currentStep: (state) => state.apply.currentStep,
    }),
    activeStepComponent() {
      if (this.terminal) return TERMINAL[this.terminal]
      return STEPS[this.currentStep] || Step1
    },
  },
  created() {
    this.hydrateFromStorage()
    const { ref, city, wa } = this.$route.query
    if (ref) this.setRefSource(ref)
    if (city) this.setField({ key: 'ciudad', value: this.normalizeCity(city) })
    if (wa) this.setField({ key: 'wa_user_id', value: String(wa) })
  },
  methods: {
    ...mapMutations('apply', ['setCurrentStep', 'setRefSource', 'setField']),
    ...mapActions('apply', ['hydrateFromStorage']),
    onNext() {
      const next = Math.min(this.currentStep + 1, 11)
      this.setCurrentStep(next)
      window.scrollTo(0, 0)
    },
    onBack() {
      const prev = Math.max(this.currentStep - 1, 1)
      this.setCurrentStep(prev)
      window.scrollTo(0, 0)
    },
    goto(step) {
      this.setCurrentStep(step)
      window.scrollTo(0, 0)
    },
    setTerminal(key) {
      this.terminal = key
      window.scrollTo(0, 0)
    },
    normalizeCity(slug) {
      const map = {
        popayan: 'Popayán',
        pereira: 'Pereira',
        ibague: 'Ibagué',
        armenia: 'Armenia',
      }
      return map[String(slug).toLowerCase()] || slug
    },
  },
}
</script>

<style scoped>
.apply-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #fff7e6 0%, #fff 50%);
  padding: 2rem 1rem;
}
.apply-card {
  max-width: 720px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  padding: 2rem;
}
.apply-header {
  text-align: center;
  margin-bottom: 1.5rem;
}
.apply-logo {
  /* logo.png es vertical (mascota + nombre): un poco más alto que el banner anterior */
  max-height: 96px;
  margin-bottom: 0.5rem;
}
.apply-header h1 {
  font-size: 1.5rem;
  margin: 0.25rem 0;
}
.apply-sub {
  color: #777;
  font-size: 0.9rem;
}
@media (max-width: 640px) {
  .apply-card { padding: 1.25rem; }
}
</style>
